export default __webpack_public_path__ + "static/media/CNo.57-3.4527805b.jpg";